import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/(marketing)/omnienergy/page.tsx");
